/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown>, tree_name: NonNullable<unknown> }} Dailog_Redeem_Confirmation_ContentInputs */

const en_dailog_redeem_confirmation_content = /** @type {(inputs: Dailog_Redeem_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Use ${i?.number} stamps to redeem the ${i?.tree_name}?`)
};

const ar_dailog_redeem_confirmation_content = /** @type {(inputs: Dailog_Redeem_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`استخدام ${i?.number} طوابع لاستبدال ${i?.tree_name}؟`)
};

const de_dailog_redeem_confirmation_content = /** @type {(inputs: Dailog_Redeem_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} Stempel verwenden, um ${i?.tree_name} einzulösen?`)
};

const es_dailog_redeem_confirmation_content = /** @type {(inputs: Dailog_Redeem_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Usar ${i?.number} sellos para canjear ${i?.tree_name}?`)
};

const fr_dailog_redeem_confirmation_content = /** @type {(inputs: Dailog_Redeem_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Utiliser ${i?.number} timbres pour obtenir ${i?.tree_name} ?`)
};

const it_dailog_redeem_confirmation_content = /** @type {(inputs: Dailog_Redeem_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usare ${i?.number} timbri per riscattare ${i?.tree_name}?`)
};

const ja_dailog_redeem_confirmation_content = /** @type {(inputs: Dailog_Redeem_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number}スタンプを使用して${i?.tree_name}を交換しますか？`)
};

const ko_dailog_redeem_confirmation_content = /** @type {(inputs: Dailog_Redeem_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} 스탬프를 사용하여 ${i?.tree_name}을(를) 교환하시겠습니까?`)
};

const pt_br_dailog_redeem_confirmation_content = /** @type {(inputs: Dailog_Redeem_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usar ${i?.number} selos para resgatar ${i?.tree_name}?`)
};

const ru_dailog_redeem_confirmation_content = /** @type {(inputs: Dailog_Redeem_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Использовать ${i?.number} штампов, чтобы получить ${i?.tree_name}?`)
};

const th_dailog_redeem_confirmation_content = /** @type {(inputs: Dailog_Redeem_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ใช้ ${i?.number} แสตมป์เพื่อแลกรับ ${i?.tree_name} หรือไม่?`)
};

const tr_dailog_redeem_confirmation_content = /** @type {(inputs: Dailog_Redeem_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tree_name} almak için ${i?.number} pul kullanılsın mı?`)
};

const zh_cn_dailog_redeem_confirmation_content = /** @type {(inputs: Dailog_Redeem_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`使用 ${i?.number} 印花兑换${i?.tree_name}吗？`)
};

const zh_tw_dailog_redeem_confirmation_content = /** @type {(inputs: Dailog_Redeem_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`用 ${i?.number} 印花兌換${i?.tree_name}嗎？`)
};

/**
* | output |
* | --- |
* | "Use {number} stamps to redeem the {tree_name}?" |
*
* @param {Dailog_Redeem_Confirmation_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dailog_redeem_confirmation_content = /** @type {((inputs: Dailog_Redeem_Confirmation_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dailog_Redeem_Confirmation_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dailog_redeem_confirmation_content(inputs)
	if (locale === "ar") return ar_dailog_redeem_confirmation_content(inputs)
	if (locale === "de") return de_dailog_redeem_confirmation_content(inputs)
	if (locale === "es") return es_dailog_redeem_confirmation_content(inputs)
	if (locale === "fr") return fr_dailog_redeem_confirmation_content(inputs)
	if (locale === "it") return it_dailog_redeem_confirmation_content(inputs)
	if (locale === "ja") return ja_dailog_redeem_confirmation_content(inputs)
	if (locale === "ko") return ko_dailog_redeem_confirmation_content(inputs)
	if (locale === "pt_br") return pt_br_dailog_redeem_confirmation_content(inputs)
	if (locale === "ru") return ru_dailog_redeem_confirmation_content(inputs)
	if (locale === "th") return th_dailog_redeem_confirmation_content(inputs)
	if (locale === "tr") return tr_dailog_redeem_confirmation_content(inputs)
	if (locale === "zh_cn") return zh_cn_dailog_redeem_confirmation_content(inputs)
	return zh_tw_dailog_redeem_confirmation_content(inputs)
});